import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.4">
      <path
        d="M15.307 6.44152C14.3703 4.91596 12.2396 2.35645 8.5 2.35645C4.76039 2.35645 2.62967 4.91596 1.69296 6.44152C1.40339 6.90988 1.25 7.44964 1.25 8.00029C1.25 8.55094 1.40339 9.09071 1.69296 9.55907C2.62967 11.0846 4.76039 13.6441 8.5 13.6441C12.2396 13.6441 14.3703 11.0846 15.307 9.55907C15.5966 9.09071 15.75 8.55094 15.75 8.00029C15.75 7.44964 15.5966 6.90988 15.307 6.44152ZM14.2773 8.92674C13.4729 10.2349 11.652 12.4363 8.5 12.4363C5.34802 12.4363 3.52713 10.2349 2.72268 8.92674C2.55064 8.64835 2.45951 8.32755 2.45951 8.00029C2.45951 7.67303 2.55064 7.35223 2.72268 7.07384C3.52713 5.7657 5.34802 3.56433 8.5 3.56433C11.652 3.56433 13.4729 5.76329 14.2773 7.07384C14.4494 7.35223 14.5405 7.67303 14.5405 8.00029C14.5405 8.32755 14.4494 8.64835 14.2773 8.92674Z"
        fill="#151718"
      />
      <path
        d="M8.5 4.98058C7.90276 4.98058 7.31893 5.15768 6.82234 5.48949C6.32575 5.8213 5.9387 6.29292 5.71015 6.8447C5.48159 7.39648 5.42179 8.00364 5.53831 8.58941C5.65482 9.17518 5.94242 9.71324 6.36474 10.1356C6.78705 10.5579 7.32512 10.8455 7.91088 10.962C8.49665 11.0785 9.10381 11.0187 9.65559 10.7901C10.2074 10.5616 10.679 10.1745 11.0108 9.67796C11.3426 9.18137 11.5197 8.59754 11.5197 8.00029C11.5188 7.19971 11.2003 6.43219 10.6342 5.86609C10.0681 5.29999 9.30058 4.98154 8.5 4.98058ZM8.5 9.81212C8.14165 9.81212 7.79136 9.70586 7.4934 9.50677C7.19545 9.30769 6.96322 9.02472 6.82609 8.69365C6.68896 8.36258 6.65308 7.99828 6.72298 7.64682C6.79289 7.29536 6.96545 6.97252 7.21884 6.71914C7.47223 6.46575 7.79507 6.29319 8.14653 6.22328C8.49799 6.15337 8.86229 6.18925 9.19336 6.32638C9.52443 6.46351 9.80739 6.69574 10.0065 6.99369C10.2056 7.29165 10.3118 7.64195 10.3118 8.00029C10.3118 8.48082 10.1209 8.94166 9.78116 9.28145C9.44137 9.62123 8.98053 9.81212 8.5 9.81212Z"
        fill="#151718"
      />
    </g>
  </svg>
);

const EyeFull = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default EyeFull;
